module.exports = __webpack_public_path__ + "img/icon_trade_contract_trade_contract_propose.0da90828.svg";